import { render, staticRenderFns } from "./WorkflowPrepProcessDetail.vue?vue&type=template&id=379265a7"
import script from "./WorkflowPrepProcessDetail.vue?vue&type=script&lang=js"
export * from "./WorkflowPrepProcessDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports